function reinitializeCustomJs() {
  function generateDateRange() {
    var today = new Date();

    // Add 3 days to today's date
    var ThreeDaysLater = new Date(today);
    ThreeDaysLater.setDate(today.getDate() + 3);

    if (today.getDay() >= 4 || today.getDay() == 0) {
      ThreeDaysLater.setDate(ThreeDaysLater.getDate() + 1);
    }

    var formatOptions = { month: "short", day: "numeric" };

    return {
      today: today.toLocaleDateString("en-US", formatOptions),
      ThreeDaysLater: ThreeDaysLater.toLocaleDateString("en-US", formatOptions),
    };
  }

  var dateRange = generateDateRange();

  const deliveryDate = document.getElementById("delivery_date");
  if (deliveryDate) {
    deliveryDate.innerHTML = `${dateRange.ThreeDaysLater}`;
  }

  if (window.location.href.includes("/product")) {
    function removeVariantFromUrl() {
      let url = window.location.href;
      url = url.replace(/\?variant=\d+/, "");
      window.history.replaceState({}, document.title, url);
    }
    removeVariantFromUrl();
  }

  // Size Scroll

  let atcDisable = document.querySelector(
    '.stickty_atc_wrapper button[name="add"]'
  );
  let goKwikBuy = document.querySelector("#gokwik-buy-now");
  let shopfloBuy = document.querySelector("#flo-buy-now-button");
  let selectSize = document.querySelector(".select_size");
  let selectSizePopup = document.querySelector(".select_size_popup");
  let sizeElement = document.querySelector("div[data-product-blocks]");
  let fieldSet = document.querySelector(".variant-wrapper .variant-input-wrap");
if (!selectSizePopup || !fieldSet) {
  return;
}

  // For add to cart

  // touchstart event for touch device
  atcDisable?.addEventListener("touchstart", function () {
    if (atcDisable.hasAttribute("disabled")) {
      selectSizePopup.style.left = "20px";
      selectSizePopup.style.right = "unset";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  // pointerdown event for desktop
  atcDisable?.addEventListener("pointerdown", function () {
    if (atcDisable.hasAttribute("disabled")) {
      selectSizePopup.style.left = "20px";
      selectSizePopup.style.right = "unset";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  // For Gokwik button

  // touchstart event for touch device
  goKwikBuy?.addEventListener("touchstart", function () {
    if (goKwikBuy.hasAttribute("disabled")) {
      selectSizePopup.style.left = "unset";
      selectSizePopup.style.right = "20px";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  // pointerdown event for desktop
  goKwikBuy?.addEventListener("pointerdown", function () {
    if (goKwikBuy.hasAttribute("disabled")) {
      selectSizePopup.style.left = "unset";
      selectSizePopup.style.right = "20px";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  // For shopflo button

  // touchstart event for touch device
  shopfloBuy?.addEventListener("touchstart", function () {
    if (shopfloBuy.hasAttribute("disabled")) {
      selectSizePopup.style.left = "unset";
      selectSizePopup.style.right = "20px";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  // pointerdown event for desktop
  shopfloBuy?.addEventListener("pointerdown", function () {
    if (shopfloBuy.hasAttribute("disabled")) {
      selectSizePopup.style.left = "unset";
      selectSizePopup.style.right = "20px";
      scrollToSize();
      fieldSet.classList.add("vibrating");
      setTimeout(() => {
        fieldSet.classList.remove("vibrating");
      }, 500);
    }
  });

  function scrollToSize() {
    if (sizeElement) {
      selectSize.classList.remove("hidden");
      selectSizePopup.classList.remove("hidden");
      sizeElement.scrollIntoView({ behavior: "smooth" });
    }
  }



  // Store Rating Scroll

document
  .querySelectorAll("#store_rating_scroll, #store_rating_scroll_mobile")
  .forEach((storeRating) => {
    storeRating.addEventListener("click", function (e) {
      e.preventDefault();

      const reviewTitle = document.querySelector(
        ".scroll_review .section-header"
      );

      if (reviewTitle) {
        const headerOffset = 100;

        const offsetPosition =
          reviewTitle.getBoundingClientRect().top +
          window.pageYOffset -
          headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
    });
  });

  // Review Scroll

  let brand_review = document.getElementById("brand_review");
  brand_review?.addEventListener("click", scrollToReview);

  function scrollToReview() {
    var reviewElement = document.querySelector(".scroll_review");

    if (reviewElement) {
      // reviewElement.style.paddingTop = "35%";
      reviewElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  // for share product
  document.getElementById("share-button")?.addEventListener("click", () => {
    navigator
      .share({
        title: document.title,
        text: document.title,
        url: window.location.href,
      })
      .then(() => console.log("Successful share! 🎉"))
      .catch((err) => console.error(err));
  });

  // by default hide Sticky atc

 

let stickyATC = document.querySelector(".stickty_atc_wrapper");

if (stickyATC) {
  stickyATC.classList.remove("hidden-mobile");
}

  // by default hide Notify btn

  let notifyBlock = document.querySelector(
    "#shopify-block-notify_me_restock_alert_app_block_QGMKrz"
  );

  notifyBlock?.classList.add("hidden-mobile");

  window.addEventListener("scroll", function () {
    if (notifyBlock) {
      if (window.scrollY >= 200) {
        notifyBlock.classList.remove("hidden-mobile");
      } else {
        notifyBlock.classList.add("hidden-mobile");
      }
    }
  });

  function copyToClipboardStaticOffer(element) {
    // Find the closest span with class 'copyText' and get its text
    const copyText = element.previousElementSibling.innerText;

    // Create a temporary input element
    const tempInput = document.createElement("input");
    tempInput.value = copyText;
    document.body.appendChild(tempInput);

    // Select the text in the input field
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the text inside the input field
    document.execCommand("copy");

    // Remove the temporary input element
    document.body.removeChild(tempInput);

    // Optional: Show a success message or change the icon temporarily
    alert("Copied to clipboard: " + copyText);
  }



}
reinitializeCustomJs();

function reinitializeVideoCallJs() {
  const popup = document.getElementById("vc_popup");
  const openPopupBtns = document.querySelectorAll(".video_call_btn");
  const closePopupBtn = document.querySelector(".close-btn");
  const body = document.body; // Reference to the body element

  // Open popup
  openPopupBtns.forEach((openPopupBtn) => {
    openPopupBtn?.addEventListener("click", () => {
      popup.classList.remove("hidden");
      body.classList.add("no-scroll"); // Disable body scrolling
    });
  });

  // Close popup
  closePopupBtn?.addEventListener("click", () => {
    popup.classList.add("hidden");
    body.classList.remove("no-scroll"); // Enable body scrolling
  });

  // Close popup when clicking outside the content
  popup?.addEventListener("click", (e) => {
    if (e.target === popup) {
      popup.classList.add("hidden");
      body.classList.remove("no-scroll"); // Enable body scrolling
    }
  });
}
reinitializeVideoCallJs();

let currentTab = "single";
if (window.location.pathname.includes("2-pack")) {
  currentTab = "pack_of_2";
} else if (window.location.pathname.includes("3-pack")) {
  currentTab = "pack_of_3";
}
function collapsTab() {
  const tabButtons = document.querySelectorAll(".tab_btn");
  const tabContents = document.querySelectorAll(".tab_content");

  const activateTab = (tab) => {
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    tabContents.forEach((content) => content.classList.add("hidden"));
    document.getElementById(tab)?.classList.remove("hidden");
    tabButtons.forEach((btn) => {
      if (btn.getAttribute("data-tab") === tab) {
        btn.classList.add("active");
      }
    });
    currentTab = tab;
  };

  const selectFirstBtn = (tab) => {
    let parentElement = document.getElementById(tab);
    let childElement = parentElement.querySelector(".product_btn");
    childElement.click();
  };

  // Add click event listener to tab buttons
  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const targetTab = button.getAttribute("data-tab");
      activateTab(targetTab);
      selectFirstBtn(targetTab);
    });
  });

  // Automatically select the correct tab when a product is selected
  document.querySelectorAll(".product_btn").forEach((product) => {
    product.addEventListener("click", () => {
      const tab = product.closest(".tab_content")?.id;
      activateTab(tab);
    });
  });

  // Open the first tab by default
  activateTab(currentTab);
}
collapsTab();
